import { Component, OnInit } from '@angular/core';
import { NotificationAdminService, NotificationLog } from '../../../shared/services/notification-admin.service';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-notification-log',
    templateUrl: './notification-log.component.html',
    styleUrls: ['./notification-log.component.css'],
    standalone: false
})
export class NotificationLogComponent implements OnInit {
  logs: NotificationLog[] = [];
  totalCount = 0;
  loading = false;

  pageSize = 20;
  skip = 0;

  eventTypes: string[] = [];
  selectedEventType: string | null = null;
  selectedStatus: string | null = null;

  statusOptions = ['Sent', 'Failed', 'Queued'];

  selectedLog: NotificationLog | null = null;
  showDetailsDialog = false;

  constructor(private notificationAdminService: NotificationAdminService) { }

  ngOnInit(): void {
    this.loadEventTypes();
    this.loadLogs();
  }

  loadEventTypes(): void {
    this.notificationAdminService.getEventTypes().subscribe({
      next: (types) => {
        this.eventTypes = types;
      }
    });
  }

  loadLogs(): void {
    this.loading = true;

    this.notificationAdminService.getLogs({
      skip: this.skip,
      take: this.pageSize,
      eventType: this.selectedEventType || undefined,
      status: this.selectedStatus || undefined
    }).subscribe({
      next: (response) => {
        this.logs = response.logs;
        this.totalCount = response.totalCount;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading logs', err);
        this.loading = false;
      }
    });
  }

  onPageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadLogs();
  }

  onFilterChange(): void {
    this.skip = 0;
    this.loadLogs();
  }

  clearFilters(): void {
    this.selectedEventType = null;
    this.selectedStatus = null;
    this.skip = 0;
    this.loadLogs();
  }

  viewDetails(log: NotificationLog): void {
    this.selectedLog = log;
    this.showDetailsDialog = true;
  }

  closeDetailsDialog(): void {
    this.showDetailsDialog = false;
    this.selectedLog = null;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Sent':
        return 'status-sent';
      case 'Failed':
        return 'status-failed';
      case 'Queued':
        return 'status-queued';
      default:
        return '';
    }
  }

  parseRecipients(recipientsJson: string): string[] {
    try {
      return JSON.parse(recipientsJson);
    } catch {
      return [recipientsJson];
    }
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleString();
  }
}
